"use client";

import { c as _c } from "react/compiler-runtime";
import { usePrevious } from "@opensea/ui-kit/hooks";
import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import { useAccount as useWagmiAccount } from "wagmi";
import { useConnections } from "../polychain/hooks";
import { AccountActions, AccountState } from "../stores/accountStore";

// Fix for OS2-13248
export function useFixChainArch() {
  const $ = _c(16);
  const {
    ready,
    address,
    chainArch
  } = useSnapshot(AccountState);
  const connections = useConnections();
  const {
    isConnecting
  } = useWagmiAccount();
  const prevIsConnecting = usePrevious(isConnecting) ?? false;
  const [isWagmiReady, setIsWagmiReady] = useState(false);
  let t0;
  if ($[0] !== isConnecting || $[1] !== prevIsConnecting) {
    t0 = () => {
      setIsWagmiReady(prev => prev || !isConnecting && prevIsConnecting);
    };
    $[0] = isConnecting;
    $[1] = prevIsConnecting;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== isConnecting || $[4] !== prevIsConnecting || $[5] !== ready) {
    t1 = [isConnecting, prevIsConnecting, ready];
    $[3] = isConnecting;
    $[4] = prevIsConnecting;
    $[5] = ready;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  let t2;
  if ($[7] !== address || $[8] !== chainArch || $[9] !== connections || $[10] !== isWagmiReady || $[11] !== ready) {
    t2 = () => {
      if (ready && isWagmiReady && !address) {
        if (chainArch === "SVM" && connections.some(_temp)) {
          AccountActions.setActiveChainArch("EVM");
        }
        if (chainArch === "EVM" && connections.some(_temp2)) {
          AccountActions.setActiveChainArch("SVM");
        }
      }
    };
    $[7] = address;
    $[8] = chainArch;
    $[9] = connections;
    $[10] = isWagmiReady;
    $[11] = ready;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== isWagmiReady || $[14] !== ready) {
    t3 = [ready, isWagmiReady];
    $[13] = isWagmiReady;
    $[14] = ready;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  useEffect(t2, t3);
}
function _temp2(c_0) {
  return c_0.chainArch === "SVM";
}
function _temp(c) {
  return c.chainArch === "EVM";
}